import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
  ).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1.5 h-5 rounded-full bg-secondary-500"></div>
              <span className="text-xs font-semibold text-secondary-700 uppercase tracking-wider">
                最新内容
              </span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新文章更新
            </h2>
            <p className="text-sm text-foreground-600 mt-2">
              持续更新鬼父2深度解析，不错过任何精彩内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer border border-background-200/60 hover:border-primary-200 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="h-[200px] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-accent-100 text-accent-800">
                    {article.category === 'plot' ? '剧情解析' :
                     article.category === 'characters' ? '人物介绍' :
                     article.category === 'classic-scenes' ? '经典场景' :
                     article.category === 'themes' ? '主题分析' : '续集看点'}
                  </span>
                  {article.hot && (
                    <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-primary-100 text-primary-700">
                      热门
                    </span>
                  )}
                </div>
                <h3 className="font-heading text-base font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i> {article.publishDate}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i> {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}